import { useCallback, useEffect, useState } from 'react';

/**
 * A one-second countdown for client-side throttles ("Resend in 24s").
 * `start(n)` (re)arms it at n seconds, `clear()` ends it; `remaining` is 0
 * when the guarded action is available again.
 */
export const useCooldown = () => {
    const [remaining, setRemaining] = useState(0);

    useEffect(() => {
        if (remaining <= 0) return;
        const timer = window.setTimeout(() => setRemaining((seconds) => seconds - 1), 1000);
        return () => window.clearTimeout(timer);
    }, [remaining]);

    const start = useCallback((seconds: number) => setRemaining(seconds), []);
    const clear = useCallback(() => setRemaining(0), []);

    return { remaining, start, clear };
};
